import { render, staticRenderFns } from "./form.vue?vue&type=template&id=371b3c72&scoped=true&"
import script from "./form.vue?vue&type=script&lang=js&"
export * from "./form.vue?vue&type=script&lang=js&"
import style0 from "./form.vue?vue&type=style&index=0&id=371b3c72&prod&lang=scss&scoped=true&"
import style1 from "./form.vue?vue&type=style&index=1&id=371b3c72&prod&lang=css&"
import style2 from "./form.vue?vue&type=style&index=2&id=371b3c72&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371b3c72",
  null
  
)

export default component.exports